import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
import Home from '@/components/pages/home/'
import Oversight from '@/components/pages/oversight/'
import Dementia from '@/components/pages/dementia/'
import Improv from '@/components/pages/improvement/'
import Recourses from '@/components/pages/recourses/'
import Material from '@/components/pages/material/'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/oversight',
      name: 'Oversight',
      component: Oversight
    },
    {
      path: '/dementia',
      name: 'Dementia',
      component: Dementia
    },
    {
      path: '/improvement',
      name: 'Improvement',
      component: Improv
    },
    {
      path: '/recourses',
      name: 'Recourses',
      component: Recourses
    },
    {
      path: '/material',
      name: 'Material',
      component: Material
    },

    {
      path: '*',
      name: 'HomeAll',
      component: Home
    }
  ]
})
Vue.use(VueAnalytics, {
  id: 'UA-155544056-1',
  router
})

router.beforeEach((to, from, next) => {
  try {
    document.getElementById('app').scrollTop = 0
  } catch (e) {
    console.log(e.toString())
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js